import {
  GET_WORKFLOW_MARKETPLACE_WORKFLOWS,
  GET_WORKFLOW_MARKETPLACE_WORKFLOW_IMAGES,
} from '../../state/actionTypes';
import WorkflowMarketplaceService from './workflowMarketplace.service';

export default {};

export const getWorkflowMarketplaceWorkflows = () => async (dispatch) => {
  const { data } = await WorkflowMarketplaceService.getWorkflows();
  if (!data) return false;
  dispatch({
    type: GET_WORKFLOW_MARKETPLACE_WORKFLOWS,
    payload: data,
  });
  return true;
};

export const getWorkflowMarketplaceWorkflowImages = (name) => async (dispatch) => {
  const { data } = await WorkflowMarketplaceService.getWorkflowImages(name);
  if (!data) return false;
  dispatch({
    type: GET_WORKFLOW_MARKETPLACE_WORKFLOW_IMAGES,
    payload: { name, images: data },
  });
  return true;
};

export const importWorkflowMarketplaceWorkflow = ({ id, name, divisions }) => async () => {
  const { data } = await WorkflowMarketplaceService.importWorkflow({ id, name, divisions });
  return !!data;
};
